const getTestIdWithModifier = (testId: string, modifier?: string): string =>
    `${testId}${modifier ? `--${modifier}` : ''}`;

export const errorMessages = new Map([
    ['confirm', {
        message: 'Passwords do not match.',
        test: (newP: string, confirmP: string) => newP !== confirmP,
    }],
    ['length', {
        message: 'Password must be greater than 8 characters in length.',
        test: (newP: string) => newP.length < 8,
    }],
    ['sequential', {
        message: 'Password must not contain more than two sequential characters.',
        test: (newP: string) => newP.match(/(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|yza|zab|012|123|234|345|456|567|678|789|890|901|cba|dcb|edc|fed|gfe|hgf|ihg|jih|kji|lkj|mlk|nml|onm|pon|qpo|rqp|srq|tsr|uts|vut|wvu|xwv|yxw|zyx|azy|baz|210|321|432|543|654|765|876|987|098|109)+/ig),
    }],
    ['number', {
        message: 'Password must contain at least one number.',
        test: (newP: string) => !newP.match(/\d/),
    }],
    ['equal', {
        message: 'Password must not contain more that two consecutive equal characters.',
        test: (newP: string) => newP.match(/(\w)\1{2,}/),
    }],
]) 

const getErrorObject = (field: string) => (key: string) => ({ field, error: true, message: errorMessages.get(key)?.message || '' });

export const passwordCheck = (newPassword: string, confirmPassword: string): { field: string; error: boolean;  message: string}[] => {
    const error = getErrorObject('password');

    const errors = [...errorMessages.keys()].filter(item => errorMessages.get(item)?.test(newPassword, confirmPassword)).map(item => error(item))
    
    return errors;
}

export default getTestIdWithModifier;
